import React from 'react';

import IconTIApp from '@components/Images/Rebranding/IconTIApp';
import LazyImgixImage from '@components/LazyImgixImage';

import { APP_IMAGE_URL } from './constants';

const AppSection = () => (
  <section className="mx-auto max-w-[900px] border-0 border-b border-solid border-grayscale-charcoal pt-64 sm:pt-112">
    <div className="flex flex-col items-center gap-32 sm:gap-64 md:flex-row">
      <LazyImgixImage
        className="mx-auto block h-auto w-full max-w-[325px]"
        src={APP_IMAGE_URL}
        wrapperClassName="order-2 md:order-1"
      />

      <div className="order-1 flex flex-col items-start gap-24 md:order-2 md:max-w-[500px]">
        <IconTIApp className="h-80 w-auto" />
        <div className="flex flex-col gap-8">
          <h2 className="m-0 font-suisse-works text-headline-xxs text-primary-black sm:text-headline-sm md:text-headline-md">
            The Information App
          </h2>
          <p className="m-0 font-suisse-neue text-body-lg text-primary-black">
            Stay ahead from anywhere. Our app delivers our latest tech and AI news, analysis and
            alerts—so you never miss what matters.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default AppSection;
